var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 0C5.8 0 4 1.8 4 4V5H2C1.4 5 1 5.4 1 6V15C1 15.6 1.4 16 2 16H14C14.6 16 15 15.6 15 15V6C15 5.4 14.6 5 14 5H12V4C12 1.8 10.2 0 8 0ZM9 11.7V13H7V11.7C6.4 11.4 6 10.7 6 10C6 8.9 6.9 8 8 8C9.1 8 10 8.9 10 10C10 10.7 9.6 11.4 9 11.7ZM8 1.5C6.61929 1.5 5.5 2.61929 5.5 4V5H10.5V4C10.5 2.61929 9.38071 1.5 8 1.5Z","fill":"#181818"}));
}

Lock.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Lock;

Lock.default = Lock;
